import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import createOfferSdk from './offer-sdk/index';
import bankingProductsSDK from './offer-sdk/banking-products';
export var BankingProductsSDK = function BankingProductsSDK(_ref) {
  var ServiceSDK = _ref.ServiceSDK,
      config = _objectWithoutProperties(_ref, ["ServiceSDK"]);

  return bankingProductsSDK(ServiceSDK, config);
};
/*
Return an offersSDK library instance.
Note that NWApiSDK instances do hold state, namely "identify" tracking state inside ServiceSDK.

config:
- clientID: your FE app's unique client ID
- offersBaseURL: the offers api base URL for your current environment
*/

export default function (_ref2) {
  var ServiceSDK = _ref2.ServiceSDK,
      config = _objectWithoutProperties(_ref2, ["ServiceSDK"]);

  return createOfferSdk(ServiceSDK, config);
}